/* eslint-disable @typescript-eslint/camelcase */
import React from 'react'
import ReactDOM from 'react-dom'
import intl from 'react-intl-universal'

import template from './template.html'
import { getStoryOperationInProgress } from '~/redux/appReducer'
import WorkflowModal from '~/reactapp/App/WorkflowModal'
import { setStoryAns } from '~/redux/storyData'

function reactRenderFactory(angularScope, rootElement, WorkflowModal) {
  angularScope.$on('$destroy', () =>
    ReactDOM.unmountComponentAtNode(rootElement)
  )

  return (props) => {
    ReactDOM.render(<WorkflowModal {...props} />, rootElement)
  }
}

function Link(scope, el) {
  const rootElement = el.find('#workflow-modal-react')[0]
  scope.vm.renderModal = reactRenderFactory(scope, rootElement, WorkflowModal)
}

class WebskedButtonsController {
  constructor(
    $ngRedux,
    $scope,
    $location,
    webskedService,
    storyService,
    padlockService,
    storyTemplateService,
    toastr,
    getErrorMessage,
    webskedData
  ) {
    this.$location = $location
    this.webskedService = webskedService
    this.storyService = storyService
    this.padlockService = padlockService
    this.storyTemplateService = storyTemplateService
    this.toastr = toastr
    this.webskedData = webskedData
    this.isStoryCreationPage = $location.path() === '/story'
    this.intl = intl
    this.$ngRedux = $ngRedux

    this.oldStatus = ''
    this.hasChanges = false
    this.storyObj = null
    this.getErrorMessage = getErrorMessage

    const ngReduxUnsubscribe = $ngRedux.connect((state) => ({
      isStoryOperationInProgress: getStoryOperationInProgress(state),
    }))(this)

    $scope.$on('$destroy', () => {
      ngReduxUnsubscribe()
    })

    this.fetchStory()
  }

  fetchStory() {
    this.storyService
      .getStory()
      .then((story) => {
        this.storyObj = story

        // can edit if a new story, or not a locked one.
        this.canEdit =
          !this.storyObj._id || this.padlockService.hasLock(this.storyObj._id)
        this.oldStatus = this.storyObj.workflow.status_code
      })
      .catch((error) => {
        this.toastr.error(
          intl.get('WebskedButtons.fetchStory.errorWithMsg', {
            errorMessage: this.getErrorMessage(
              error,
              'Error while fetching story in WebskedButtonsController'
            ),
          }),
          intl.get('common.error')
        )
      })
  }

  saveStory(andExit) {
    this.hasChanges = true

    // Save for Story or Templates
    const path = this.$location.path()

    if (path === '/template') {
      this.storyTemplateService.save().then(() => {
        this.$location.path('settings')
      })
    } else if (andExit) {
      this.storyService.saveAndRedirect('search')
    } else {
      this.storyService.save(true)
    }
  }

  getModalProps(isOpen) {
    return {
      isOpen,
      onClose: this.closeModal,
      onSave: this.handleSaveClick,
      webskedButtons: this.webskedData.buttons,
      note: this.storyObj.workflow.note,
      statusCode: this.storyObj.workflow.status_code,
    }
  }

  showModal() {
    if (!this.storyObj) {
      this.toastr.error(
        intl.get('WebskedButtons.fetchStory.error'),
        intl.get('common.error')
      )
    } else {
      this.renderModal(this.getModalProps(true))
    }
  }

  closeModal = () => {
    this.renderModal(this.getModalProps(false))
  }

  handleSaveClick = ({ note, status }, andExit = false) => {
    // Update directive state for UI
    this.storyObj.workflow.note = note
    this.storyObj.workflow.status_code = status

    // Update redux for story save
    const reduxStoryData = this.$ngRedux.getState().storyData
    const { story } = reduxStoryData
    this.$ngRedux.dispatch(
      setStoryAns({
        storyAns: { ...story, workflow: { note, status_code: status } },
      })
    )

    this.closeModal()
    this.saveStory(andExit)
  }
}

export default function directive() {
  return {
    restrict: 'E',
    template,
    replace: true,
    bindToController: true,
    controllerAs: 'vm',
    controller: [
      '$ngRedux',
      '$scope',
      '$location',
      'webskedService',
      'storyService',
      'padlockService',
      'storyTemplateService',
      'toastr',
      'getErrorMessage',
      WebskedButtonsController,
    ],
    scope: {
      webskedData: '=',
    },
    link: Link,
  }
}
